// @ts-nocheck
import { useState } from "react";
import { CustomSelectInput } from "./Input";
import PropTypes from "prop-types";
import { CustomChip } from "./CustomIconButton";
import { TextField } from "@mui/material";

export const EquipmentInput = ({
  name,
  placeholder,
  values,
  setFieldValue,
  readOnly,
  handleBlur,
  options = [],
  biggerInput = false,
}) => {
  const [equipments, setEquipments] = useState("");

  return (
    <CustomSelectInput
      style={{ marginBottom: biggerInput ? 0 : "1rem", height: "auto" }}
      onChange={(event, value) => setFieldValue(value)}
      value={values}
      fullWidth
      // open={options?.length > 0}
      readOnly={readOnly}
      inputValue={equipments}
      sx={{
        "& input": {
          color: "white",
        },
        "& .MuiInputBase-root": {
          ...(!biggerInput
            ? {
                py: "2px !important",
              }
            : {}),
        },
        ...(biggerInput
          ? {
              "& .MuiInputBase-root": {
                height: "auto",
              },
            }
          : {}),
      }}
      onInputChange={(event, newInputValue) => {
        const splitOptions = newInputValue?.split(";");
        if (splitOptions?.length > 1) {
          setFieldValue([...values, ...splitOptions]);
          setEquipments("");
        } else {
          setEquipments(newInputValue);
        }
      }}
      options={options || []}
      componentsProps={{
        paper: {
          style: {
            display: "block",
            background: "black",
            outline: "1px solid white",
            borderRadius: "8px",
          },
        },
      }}
      renderOption={(props, option) => (
        <li
          {...props}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {option}
        </li>
      )}
      renderTags={(value, getTagProps) => {
        return value.map((option, index) =>
          option ? (
            <CustomChip
              key={index}
              label={option}
              {...getTagProps({ index })}
              onDelete={() => {
                setFieldValue(values.filter((item) => item !== option));
              }}
            />
          ) : null,
        );
      }}
      renderInput={(params) => (
        <>
          <TextField
            {...params}
            variant="outlined"
            name={name ?? "equipmentProvided"}
            onBlur={handleBlur}
            placeholder={placeholder ?? "Type your equipment with ; separated"}
            onKeyDown={(e) => {
              if (e.key === ";" || e.key === ",") {
                e.preventDefault();
                setFieldValue([...values, equipments]);
                setEquipments("");
              }
            }}
          />
        </>
      )}
    />
  );
};

EquipmentInput.propTypes = {
  values: PropTypes.array,
  setFieldValue: PropTypes.func,
  readOnly: PropTypes.bool,
  handleBlur: PropTypes.func,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  biggerInput: PropTypes.bool,
};